import { createContext, useContext } from "react";

export const EddUploadContext = createContext({
  isGlobalUploading: false,
  setIsGlobalUploading: () => {},
});

export const useEddUploadContext = () => useContext(EddUploadContext);
